// Create the bars
const indicator = document.getElementById("scroll-indicator");
const totalBars = 30;
const bars = [];

for (let i = 0; i < totalBars; i++) {
  const bar = document.createElement("div");
  bar.classList.add("scroll-bar");
  indicator.appendChild(bar);
  bars.push(bar);
}

// Update active bars based on scroll
function updateBars() {
  const scrollTop = window.scrollY;
  //   console.log("scrollTop", scrollTop);
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  //   console.log("docHeight", docHeight);
  const scrollRatio = scrollTop / docHeight;

  bars.forEach((bar) => {
    bar.classList.remove("active");
    bar.style.transform = "scaleX(1)";
  });

  let activeStart = 0;
  if (scrollRatio < 0.3) {
    activeStart = 0;
  } else if (scrollRatio < 0.7) {
    activeStart = 10;
  } else {
    activeStart = 20;
  }

  const activeCount = 10;
  for (let i = 0; i < activeCount; i++) {
    const index = activeStart + i;
    const bar = bars[index];
    if (!bar) continue;

    bar.classList.add("active");

    // Calculate scale: middle is longest
    const distanceFromCenter = Math.abs(i - activeCount / 2 + 0.5);
    const scale = 0.6 + (1 - distanceFromCenter / (activeCount / 2)) * 0.6;
    bar.style.transform = `scaleX(${scale})`;
  }
}

window.addEventListener("scroll", updateBars);
updateBars();
